import { request } from '../api'
import dealerQuery from '../queries/dealer.gql'
import Home from './Home'
import SRP from './SRP'
import VDP from './VDP'
import { CustomerBoard } from '~/plugins/board'

export default [
  { path: '/', component: Home },
  { path: '/board', component: CustomerBoard, name: 'board' },
  { path: '/board/:opportunity', component: CustomerBoard },
  {
    path: '/dealer/:buid/:pathMatch(.*)?',
    component: SRP,
    async beforeEnter (to, from, next) {
      const response = await Promise.resolve(request(dealerQuery, {
        dealerId: to.params.buid
      }))
      const { dealer } = response.data
      to.meta.logo = dealer?.logo?.url
      next()
    }
  },
  { path: '/search(.*)?', component: SRP, name: 'srp' },
  { path: '/vehicle/:inventory', component: VDP, name: 'vdp', props: true },
  {
    path: '/vehicle/:inventory/embed',
    component: VDP,
    name: 'vdp-embed',
    props: true,
    meta: { layout: 'embed' }
  }
]
